import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';
import Button from 'src/componentes/button';
import Checkbox from 'src/componentes/checkbox';
import Drawer from 'src/componentes/drawer';
import InputNumber from 'src/componentes/input-number';
import Select2 from 'src/componentes/select2';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import CargoLookup from 'src/lookups/cargo';
import OrganizacaoLookup from 'src/lookups/item-organizacao';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

import { PERFIL_LIDERANCA } from './constants';

const ParticipantesFiltroDrawer = ({
  filtro,
  focusTrapPriority = 2,
  onAplicarFiltro,
  onChangeFiltro,
  onClearFiltro,
  onClose,
  open,
}) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const perfilLiderancaLabel = intl.formatMessage({
    id: 'labelPerfilLideranca',
  });
  const perfisLideranca = [
    {
      id: PERFIL_LIDERANCA.TODOS,
      descricao: intl.formatMessage({ id: 'todos' }),
    },
    {
      id: PERFIL_LIDERANCA.LIDERES,
      descricao: intl.formatMessage({
        id: 'labelPerfilLiderancaLideres',
      }),
    },
    {
      id: PERFIL_LIDERANCA.NAO_LIDERES,
      descricao: intl.formatMessage({
        id: 'labelPerfilLiderancaNaoLideres',
      }),
    },
  ];

  return (
    <Drawer
      open={open}
      close={onClose}
      title={
        <div
          className="font-weight-bold pt-4 pb-4"
          style={{
            color: '#404040',
            fontSize: '1.25rem',
          }}
        >
          {capitalizeFirstLetter(
            intl.formatMessage({ id: 'labelAdicionarParticipantes' })
          )}
        </div>
      }
      position="right"
      size={430}
      zIndex={12000}
      focusTrap
      focusTrapPriority={focusTrapPriority}
      actions={
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <span
            style={{
              color: '#0D7E94',
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 'bold',
            }}
            onClick={onClearFiltro}
          >
            {intl.formatMessage({ id: 'limparTodos' })}
          </span>
          <Button
            color="primary"
            leftIcon="plus"
            onClick={onAplicarFiltro}
            style={{ width: '7rem' }}
          >
            {intl.formatMessage({ id: 'adicionar' })}
          </Button>
        </div>
      }
      actionsStyle={{ borderTop: '1px solid #e4eaec', padding: 20 }}
      bodyStyle={{ overflowX: 'hidden', overflowY: 'auto' }}
      headerStyle={{
        borderBottom: '1px solid #e4eaec',
        paddingBottom: 0,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 0,
      }}
    >
      <div>
        <div style={{ marginBottom: 20, fontSize: 16, fontWeight: 'bold' }}>
          {intl.formatMessage(
            { id: 'buscarPorColaborador' },
            { colaborador: resources.colaborador }
          )}
        </div>
        <Row>
          <Col md={12}>
            <ColaboradorEGrupoSimplificadoLookup
              abrirEmDrawer
              exibirGrupos
              labelComoTitulo
              compactMulti
              data={{
                ocultarInativos: true,
              }}
              multi
              model={{
                label: capitalizeFirstLetter(resources.colaboradores),
                value: filtro.colaboradoresGrupos,
                requestChange: (value) =>
                  onChangeFiltro('colaboradoresGrupos', value),
              }}
            />
          </Col>
        </Row>
        <div
          style={{
            marginTop: 10,
            marginBottom: 20,
            fontSize: 16,
            fontWeight: 'bold',
          }}
        >
          {intl.formatMessage({ id: 'buscarPorFiltros' })}
        </div>
        <Row>
          <Col md={12}>
            <InputNumber
              max={10000}
              model={{
                label: intl.formatMessage(
                  { id: 'tempoCargoDias' },
                  { cargo: resources.cargo }
                ),
                value: filtro.tempoCargoDias,
                requestChange: (value) =>
                  onChangeFiltro('tempoCargoDias', value),
              }}
            />
          </Col>
          <Col md={12}>
            <InputNumber
              max={10000}
              model={{
                label: intl.formatMessage({ id: 'tempoEmpresaDias' }),
                value: filtro.tempoEmpresaDias,
                requestChange: (value) =>
                  onChangeFiltro('tempoEmpresaDias', value),
              }}
            />
          </Col>
          <Col md={12}>
            <Select2
              aria-label={perfilLiderancaLabel}
              clearable={false}
              labelKey="descricao"
              valueKey="id"
              options={perfisLideranca}
              showHint
              idHint="perfil-lideranca-participantes-pesquisa-clima"
              labelHint={intl.formatMessage(
                {
                  id: 'hintPerfilLiderancaPesquisaClima',
                },
                {
                  pesquisa: resources.pesquisa,
                  colaboradores: resources.colaboradores,
                  colaborador: resources.colaborador,
                }
              )}
              model={{
                label: perfilLiderancaLabel,
                value: perfisLideranca.find(
                  (perfil) => perfil.id === filtro.perfilLideranca
                ),
                requestChange: (perfil) =>
                  onChangeFiltro(
                    'perfilLideranca',
                    perfil?.id ?? PERFIL_LIDERANCA.TODOS
                  ),
              }}
            />
          </Col>
          <Col md={12}>
            <CargoLookup
              clearable
              compactMulti
              multi
              model={{
                label: capitalizeFirstLetter(resources.cargos),
                value: filtro.cargos,
                requestChange: (value) => onChangeFiltro('cargos', value),
              }}
            />
          </Col>
          <Col md={12}>
            <OrganizacaoLookup
              clearable
              compactMulti
              multi
              model={{
                label: capitalizeFirstLetter(resources.areas),
                value: filtro.areas,
                requestChange: (value) => onChangeFiltro('areas', value),
              }}
            />
          </Col>
          <Col md={12}>
            <Checkbox
              className="pb-2"
              model={{
                label: intl.formatMessage(
                  {
                    id: 'label.considerarAreasSubordinadas',
                  },
                  { areas: resources.areas }
                ),
                value: filtro.considerarAreasSubordinadas,
                requestChange: (value) =>
                  onChangeFiltro('considerarAreasSubordinadas', value),
              }}
            />
          </Col>
        </Row>
      </div>
    </Drawer>
  );
};

export default ParticipantesFiltroDrawer;
